module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.$route.params.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by media file name"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "pie-wrap"
  }, [_c('spinner', {
    ref: "pieSpinner",
    attrs: {
      "size": "md",
      "text": "Loading chart data"
    }
  }), _vm._v(" "), (_vm.pieDataHasError) ? _c('div', {
    staticClass: "pie-error-wrap"
  }, [_vm._v("\n                Server error. Try to reload chart\n              ")]) : _vm._e(), _vm._v(" "), (_vm.pieDataIsReady) ? _c('pie-chart', {
    attrs: {
      "data": _vm.pieData,
      "options": _vm.pieOptions,
      "width": 500,
      "height": 250
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mt-3",
    on: {
      "click": _vm.getPieData
    }
  }, [_vm._v("Reload chart")])], 1)]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.model_type),
      expression: "filters.model_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "model_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _vm._l((_vm.contentTypes), function(value, key) {
    return _c('option', {
      key: value.namespace,
      domProps: {
        "value": value.namespace
      }
    }, [_vm._v("\n                        " + _vm._s(key) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.disk),
      expression: "filters.disk"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "disk", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "media"
    }
  }, [_vm._v("media")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "selectel"
    }
  }, [_vm._v("selectel")])])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.status),
      expression: "filters.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ok"
    }
  }, [_vm._v("ok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "failed"
    }
  }, [_vm._v("failed")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.media), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model_type))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.public_url,
        "download": ""
      }
    }, [_vm._v(_vm._s(item.file_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.disk))]), _vm._v(" "), _c('td', {
      staticClass: "text-center table-cell-loader-parent"
    }, [(!item.file_health) ? _c('span', [_vm._v("null")]) : (item.file_health.status === 'ok') ? _c('i', {
      staticClass: "fa fa-check text-success"
    }) : (item.file_health.status === 'failed') ? _c('i', {
      staticClass: "fa fa-times text-danger"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "table-cell-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "table-cell-loader-parent"
    }, [_vm._v("\n                    " + _vm._s(item.file_health ? item.file_health.date : '') + "\n                    "), _c('span', {
      staticClass: "table-cell-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "table-cell-loader-parent"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-update",
      on: {
        "click": function($event) {
          return _vm.updateHealth(item)
        }
      }
    }, [_vm._v("\n                      Update status\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "table-cell-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), _vm._v(" "), _c('tr', [(!_vm.total) ? _c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("There are no items on your request")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("\n          Media files\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Media ID")]), _vm._v(" "), _c('th', [_vm._v("Media Type")]), _vm._v(" "), _c('th', [_vm._v("File name")]), _vm._v(" "), _c('th', [_vm._v("Disk")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Last Check")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c887af","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/media/Index.vue
// module id = 948
// module chunks = 0